import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import axios from 'axios';

// DÜZELTME: Sabit liste, bileşen fonksiyonunun dışına taşındı.
// Bu, gereksiz yeniden oluşturmaları önler ve useEffect bağımlılık sorununu çözer.
const allStatusOptions = [
    { value: '1', label: 'Pending 1/4' },
    { value: '2', label: 'Send to Test 2/4' },
    { value: '3', label: 'Send to Print 3/4' },
    { value: '4', label: 'Shipped 4/4' },
    { value: '0', label: 'Cancel Order' },
    { value: 'CP', label: 'Cancel Printing (Revert to Pending)' },
];

function ChangeStatusModal({ show, orderId, currentStatus, onHide, onSuccess, apiBaseUrl }) {
    const [newStatus, setNewStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [statusOptions, setStatusOptions] = useState([]);

    useEffect(() => {
        const getAvailableOptions = () => {
            switch (String(currentStatus)) {
                case '1': // Pending
                    return allStatusOptions.filter(opt => opt.value === '0'); // Sadece 'Cancel Order'
                case '2': // Send to Test
                    return allStatusOptions.filter(opt => opt.value === '1' || opt.value === '0'); // 'Pending' ve 'Cancel Order'
                case '3': // Send to Print
                    return allStatusOptions.filter(opt => opt.value === 'CP'); // Sadece 'Cancel Printing'
                case '0': // Cancelled
                     return allStatusOptions.filter(opt => opt.value === '1'); // Sadece 'Pending' (tekrar açmak için)
                default:
                    return [];
            }
        };
        
        setStatusOptions(getAvailableOptions());
        setNewStatus('');
    // DÜZELTME: 'allStatusOptions' artık dışarıda olduğu için burada bir bağımlılık değil.
    }, [currentStatus, show]);


    const handleSubmit = async () => {
        if (!newStatus) {
            setError('Please select a new status.');
            return;
        }
        setLoading(true);
        setError('');

        const actionUrl = `${apiBaseUrl}/index.php?action=updateOrderStatus`;
        const formData = new URLSearchParams();
        formData.append('orderId', orderId);
        formData.append('status', newStatus);

        try {
            await axios.post(actionUrl, formData);
            setLoading(false);
            onSuccess();
        } catch (err) {
            setError('An error occurred while updating the status.');
            setLoading(false);
            console.error(err);
        }
    };

    const handleClose = () => {
        setNewStatus('');
        setError('');
        onHide();
    }

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Manage Order #{orderId}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {statusOptions.length > 0 ? (
                    <>
                        <p>Select a new status for this order.</p>
                        <Form>
                            <Form.Group>
                                <Form.Label>Available Actions</Form.Label>
                                <Form.Select 
                                    aria-label="Select new status"
                                    value={newStatus}
                                    onChange={(e) => setNewStatus(e.target.value)}
                                >
                                    <option value="">Choose an action...</option>
                                    {statusOptions.map(opt => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Form>
                    </>
                ) : (
                    <Alert variant="info">No actions available for the current status.</Alert>
                )}
                {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={loading || !newStatus || statusOptions.length === '0'}
                >
                    {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Confirm Change'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ChangeStatusModal;